import { Chip, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { useDateUtils } from "../../../utils/formatTime";

export default function LeadAssignConverted({
  selectedFilter,
  SelectedData,

  monthName,
  selectedYear,
  fromDate,
                            toDate,
}) {

      const { currentMonthName, lastMonthName, weekRange, currentYear } =
        useDateUtils();
        let currentDate = new Date().toISOString().split("T")[0];

  const columns = [
    {
      field: "enquiry_name",
      headerName: "Enquiry Name",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.first_name || ""} ${params?.row?.last_name || ""}`,
      renderCell: (params) => (
        <div
          style={{
            color: "#0096FF",

            cursor: "pointer",
            "&:hover": {
              textDecoration: "none",
            },
          }}
          onClick={() =>
            window.open(`/enquirydetails/${params?.row?.id}`, "_blank")
          }
        >
          {params?.row?.first_name} {params?.row?.last_name}
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.mobile || "",
      renderCell: (params) => <div>{params?.row?.mobile}</div>,
    },

    {
      field: "service",
      headerName: "Service",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.service_id?.service_name || "",
      renderCell: (params) => (
        <div>{params?.row?.service_id?.service_name}</div>
      ),
    },
    {
      field: "sub_service",
      headerName: "Sub Service",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.sub_service_id?.name || "",
      renderCell: (params) => <div>{params?.row?.sub_service_id?.name}</div>,
    },

    {
      field: "prospective_leval",
      headerName: "Prospective Leval",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params?.row?.prospective_level_id?.prospective_level || "",
      renderCell: (params) => (
        <div>{params?.row?.prospective_level_id?.prospective_level}</div>
      ),
    },
    {
      field: "stage",
      headerName: "Stage",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.stage_id?.stage_name || "",
      renderCell: (params) => <div>{params?.row?.stage_id?.stage_name}</div>,
    },
    {
      field: "assign_to",
      headerName: "Assign To",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.assign_to?.first_name || "",
      renderCell: (params) => (
        <div>
          {params?.row?.assign_to?.first_name}{" "}
          {params?.row?.assign_to?.last_name}
        </div>
      ),
    },
  ];
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {selectedFilter === "default" && (
            <Typography variant="h4" textAlign="center">
              {monthName} {selectedYear}
            </Typography>
          )}
          {selectedFilter === "today" && (
                              <Typography variant="h4" textAlign="center">
                                Today ({currentDate})
                              </Typography>
                            )}
                            {selectedFilter === "currentweek" && (
                              <Typography variant="h4" textAlign="center">
                                This Week ({weekRange})
                              </Typography>
                            )}
                    
                            {selectedFilter === "currentmonth" && (
                              <Typography variant="h4" textAlign="center">
                                {currentMonthName} {currentYear}
                              </Typography>
                            )}
                    
                            {selectedFilter === "custom" && (
                              <Typography variant="h4" textAlign="center">
                                {fromDate} - {toDate}
                              </Typography>
                            )}
                    
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            rows={SelectedData}
            columns={columns}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
          />
        </Grid>
      </Grid>
    </>
  );
}
